import React from 'react';

/** Describes the optional standard set before it can change the active model. */
export const DEFAULT_PIPEEX_PARAMETERS_CONSENT = {
  title: 'Include standard PipeEX parameters?',
  message:
    'PipeEX has a ready-made set of fields for PCF files. ' +
    'Add the full set, or keep only the fields you mapped in the wizard.',
  detailsLabel: 'What changes if you add the set',
  details: [
    {
      title: 'Added to this profile and PCF exports',
      description: (
        <>
          <strong>Project fields:</strong> PROJECT-IDENTIFIER, AREA, ATTRIBUTE1-ATTRIBUTE10.
          <br />
          <strong>System fields:</strong> PIPING-SPEC, TRACING-SPEC, ATTRIBUTE12-ATTRIBUTE23.
        </>
      ),
    },
    {
      title: 'Your Revit project will also change',
      description:
        'PipeEX adds only standard fields that are missing ' +
        'from the active project. It does not remove or replace existing fields or values.',
      emphasized: true,
    },
  ],
  confirmLabel: 'Add standard fields',
  cancelLabel: 'Keep my mappings',
  confirmColor: 'warning' as const,
} as const;
